// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Class
    name: 'g-cart-checkout__activate',
    // #endregion
    // #region Events
    emits: ["command"],
    // #endregion
    // #region Properties
    props: {
        cart: {
            type: Object,
            required: false,
            default: {}
        },
        schema: {
            type: Object,
            required: false,
            default: {}
        },
        data: {
            type: Object,
            required: false,
            default: {}
        },
        status: {
            type: Object,
            required: true,
            default: {}
        }
    },
    // #endregion
    // #region Methods
    methods: {
        async loadAfterLogin() {
            try {
                // #region Run
                await host.api.post(`commerce/carts/${this.cart.cartID}/activate`);
                // #endregion
                //#region Command
                this.$emit('command', { name: 'reload' });
                //#endregion
            }
            catch (e) {
                host.notification.showError(e);
            }
        },
    }
    // #endregion
});
// #endregion
